module.exports = __webpack_public_path__ + "img/GR.d91b332a.svg";